export default {
  exceptMobileTitle: {
    en: `<span class="brandColor">Limited-time offer:</span>
    Get 2 gift sets for just <span class="brandColor">$99</span>`,
  },
  mobileTitle: {
    en: 'Any 2 gift sets <span>for $99</span>',
  },
  buttonTitle: {
    en: 'Choose now',
  },
}
